// extracted by css-extract-rspack-plugin
export default {"color":"_1VRw6Ey59Xr2rxoTRC6g3T"};